import './settings-leaf.css';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../ui.tsx';
import { CardSaveFooter, useCompanyCardForm } from './company-card-form.tsx';
import type { Company } from '@shared/types/index.ts';

const snapshot = (company: Company) => ({
  blockCompletionOnMissingPhotos: company.blockCompletionOnMissingPhotos ?? true,
});
const toPayload = (draft: ReturnType<typeof snapshot>) => draft;

export default function ChecklistCompletionCard() {
  const { t } = useTranslation();
  const form = useCompanyCardForm(snapshot, toPayload);
  if (!form.draft) return null;
  return (
    <section className="card work-section settings-leaf mb-6">
      <div className="work-section-heading">
        <h2 className="mb-4 text-lg font-semibold">{t('checklists.completionSettings')}</h2>
      </div>
      <Checkbox
        label={t('checklists.blockCompletion')}
        checked={form.draft.blockCompletionOnMissingPhotos}
        disabled={form.readOnly}
        onChange={(event) => form.set('blockCompletionOnMissingPhotos', event.target.checked)}
      />
      <p className="mt-2 text-sm">{t('checklists.completionSettingsHint')}</p>
      <CardSaveFooter form={form} saveLabel={t('checklists.saveCompletionSettings')} />
    </section>
  );
}
